<template>
	<search-list v-if="where.time" apiPath="/channelOffer/listSummary" :where="fin_where" :handleResponse="handleResponse"  :pageSizes="[1000]">
		<mm-lc title="Adv" v-if="isChannelSummary">
			<mm-adv-select v-model="fin_where.adv_id" />
		</mm-lc>
		<mm-lc title="Channel" v-else>
			<mm-channel-select v-model="fin_where.channel_id" />
		</mm-lc>
		<mm-table slot="dataTable" slot-scope="res" :res="res" show-summary :default-sort="{prop: 'rev', order: 'descending'}" >
			<el-table-column label="Time" fixed prop="period"/>
			<el-table-column label="Adv name" prop="adv_name" fixed/>
			<el-table-column label="Channel name" prop="channel_name" fixed />
			<el-table-column label="Rev" prop="rev" sortable/>
			<el-table-column label="cost" prop="cost" sortable/>
			<el-table-column label="Deducted Rev" prop="ded_rev" sortable/>
			<el-table-column label="Deducted Rev Rate" prop="ded_rev_rate"/>
			<el-table-column label="Deducted Cost" prop="ded_cost" sortable/>
			<el-table-column label="Deducted Cost Rate" prop="ded_cost_rate"/>
			<!-- <el-table-column label="Expected Rev" prop="expected_rev" width="160" sortable>
				<span slot-scope="sp" :class="sp.row.is_expected ? 'is-expected' : 'not-expected'">
					{{sp.row.expected_rev}}
				</span>
			</el-table-column> -->
			<el-table-column label="Expected Cost" prop="expected_cost" width="160" sortable>
				<span slot-scope="sp" :class="sp.row.is_expected ? 'is-expected' : 'not-expected'">
					{{sp.row.expected_cost}}
				</span>
			</el-table-column>
			<!-- <el-table-column label="Processing Rev" prop="processing_rev" sortable/>
			<el-table-column label="Processing Rev Rate" prop="processing_rev_rate"/>
			<el-table-column label="Processing Cost" prop="processing_cost" sortable/>
			<el-table-column label="Processing Cost Rate" prop="processing_cost_rate"/>
			<el-table-column label="Hold On Rev" prop="hold_on_rev" sortable/>
			<el-table-column label="Hold On Rev Rate" prop="hold_on_rev_rate"/>
			<el-table-column label="Cover Cost" prop="cover_cost" sortable/>
			<el-table-column label="Cover Cost Rate" prop="cover_cost_rate"/> -->

		</mm-table>

	</search-list>
</template>

<script>
export default {
	props:{
		isChannelSummary:Boolean,
		where:{
			type:Object,
			default(){return {}}
		},
		period:String,
	},
	watch:{
		where(obj) {
			this.fin_where = obj;
		}
	},
	data() {
		return {
			fin_where: {},
		};
	},
	methods: {
		handleResponse(body) {
			for (const num_key in body.rows) {
				for (const key in body.rows[num_key]) {
					if (/^[0-9.]+$/.test(body.rows[num_key][key])) {
						body.rows[num_key][key] = Number(body.rows[num_key][key]);
					}
				}
			}
		}
	}
};
</script>
<style scoped>
.is-expected {
	color: green;
}
.not-expected {
	color: red;
}
</style>

